// extracted by mini-css-extract-plugin
module.exports = {"ResultsPanel":"comparable_results__ResultsPanel__ESfMz"};